// extracted by mini-css-extract-plugin
module.exports = {"cardCategory":"styles_cardCategory__ViBIm","withshadow":"styles_withshadow__RMvDr"};